module.exports = __webpack_public_path__ + "390fcf99bbb586e875e0560cf6de197b.png";